"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var QuestionBlock_1 = require("./QuestionBlock");

exports.QuestionBlock = QuestionBlock_1.default;